module.exports = "<div class=\"active-filters\" *ngIf=\"selection && selection.length > 0\">\n    <a class=\"remove-filters\" (click)=\"all()\">Alle Filter löschen</a>\n\n    Deine Auswahl:\n    <ul>\n      <li *ngFor=\"let item of selection\">\n          <a (click)=\"deselect(item)\">{{item.label}}</a>\n      </li>\n    </ul>\n</div>\n<div class=\"filter-summary\" *ngIf=\"meta\">\n    {{meta.current}} von {{meta.total}} Locations werden angezeigt\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/filter-selection/filter-selection.component.html
// module id = ./src/app/filter-selection/filter-selection.component.html
// module chunks = main